
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 90 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FDEB01","d":"M0 0l90 60H0z"}}),_c('path',{attrs:{"fill":"#58A846","d":"M90 0v60L0 0z"}}),_c('path',{attrs:{"fill":"#ED3D24","stroke":"#A02021","stroke-miterlimit":"10","d":"M54.1 35.3l14.7-10.7H50.6L45 7.3l-5.6 17.3H21.2l14.7 10.7-5.6 17.4L45 42l14.7 10.7z"}})])
          )
        }
      }
    